<template>
  <ul class="rp-list" aria-label="Requisitos de la contraseña">
    <li v-for="r in requisitos" :key="r.texto" :class="{ 'is-ok': r.ok }">
      <span class="material-symbols-outlined" aria-hidden="true">{{ r.ok ? "check_circle" : "radio_button_unchecked" }}</span>
      {{ r.texto }}
      <span class="sr-only">{{ r.ok ? "(cumplido)" : "(pendiente)" }}</span>
    </li>
  </ul>
</template>

<script>
import { requisitosPassword } from "@/directives/dbDialogs.js";

export default {
  name: "RequisitosPassword",

  props: {
    password: { type: String, default: "" },
  },

  computed: {
    requisitos() {
      return requisitosPassword(this.password);
    },
  },
};
</script>

<style scoped>
.rp-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
  font-size: 0.8rem;
  color: var(--sd-muted);
}

.rp-list li {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.rp-list .material-symbols-outlined {
  font-size: 16px;
}

.rp-list li.is-ok {
  color: var(--sd-success, #2e7d32);
}
</style>
